export const sizes: { [key: string]: string } = {
	'x-small': 'var(--epods--icon-x-small)',
	small: 'var(--epods--icon-small)',
	medium: 'var(--epods--icon-medium)',
	large: 'var(--epods--icon-large)',
	'x-large': 'var(--epods--icon-x-large)',
};

export const colors: { [key: string]: string } = {
	validated: 'var(--epods--color-signal-success-icon)',
	error: 'var(--epods--color-signal-error-icon)',
	warning: 'var(--epods--color-signal-warning-icon)',
	information: 'var(--epods--color-signal-info-icon)',
};

export const iconBaseStyle = {
	display: 'flex',
	alignItem: 'center',
};

export const cleanIconStyle = {
	paddingTop: '0',
	paddingBottom: '0',
	paddingLeft: '0',
	paddingRight: '0',
	display: 'flex',
	alignItem: 'center',
};

export const sidebarIconStyle = {
	paddingTop: 'var(--epods--space-inset-xxs)',
	paddingBottom: 'var(--epods--space-inset-xxs)',
	paddingLeft: 'var(--epods--space-inset-s)',
	paddingRight: 'var(--epods--space-inset-s)',
};

export const clearIconStyle = {
	paddingTop: '0',
	paddingBottom: '0',
	paddingLeft: '0',
	paddingRight: '0',
};

export const tagIconStyle = {
	lineHeight: '100%',
	verticalAlign: 'sub',
	paddingTop: '0',
	paddingBottom: '0',
	paddingLeft: '0',
	paddingRight: '0',
	marginTop: '-1px',
};

export const buttonIconStyle = {
	verticalAlign: 'middle',
	paddingTop: '0',
	paddingBottom: '0',
	paddingLeft: 'var(--epods--space-inset-xs)',
	paddingRight: 'var(--epods--space-inset-xs)',
};

export const buttonIconStyleBefore = {
	verticalAlign: 'middle',
	paddingTop: '0',
	paddingBottom: '0',
	paddingLeft: 'var(--epods--space-inset-xs)',
	paddingRight: 'var(--epods--space-inset-s)',
};

export const buttonIconStyleAfter = {
	verticalAlign: 'middle',
	paddingTop: '0',
	paddingBottom: '0',
	paddingLeft: 'var(--epods--space-inset-s)',
	paddingRight: 'var(--epods--space-inset-xs)',
};

export const buttonOnlyIconStyle = {
	paddingTop: '0',
	paddingBottom: '0',
	paddingLeft: '0',
	paddingRight: '0',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
};

export const notificationIconStyle = {
	lineHeight: '50px',
};

export const dialogIconStyle = {
	verticalAlign: 'middle',
	paddingTop: '0px',
	paddingBottom: '0px',
	paddingLeft: '0',
	paddingRight: 'var(--epods--space-inset-m)',
	margin: '0',
	lineHeight: 'var(--epods--line-height-h3)',
};

export const svgStyles = (props: any) => {
	let iconStyles;
	let iconSize;
	let iconColor = 'var(--epods--color-black)';
	switch (props.for) {
		case 'tag':
			iconStyles = tagIconStyle;
			iconSize = 'var(--epods--icon-x-small)';
			break;

		case 'buttonBefore':
			iconStyles = buttonIconStyleBefore;
			iconSize = 'var(--epods--icon-small)';
			break;

		case 'buttonAfter':
			iconStyles = buttonIconStyleAfter;
			iconSize = 'var(--epods--icon-small)';
			break;

		case 'onlyIconButton':
		case 'checkboxInset':
			iconStyles = buttonOnlyIconStyle;
			iconSize = 'var(--epods--icon-small)';
			break;

		case 'notification':
			iconStyles = notificationIconStyle;
			iconSize = 'var(--epods--icon-x-large)';
			break;

		case 'dialog':
			iconStyles = dialogIconStyle;
			iconSize = 'var(--epods--icon-large)';
			iconColor = 'var(--epods--color-text-ds-dark)';
			break;

		case 'sideBar':
			iconStyles = sidebarIconStyle;
			iconSize = 'var(--epods--icon-small)';
			break;

		case 'clean':
			iconStyles = cleanIconStyle;
			iconSize = 'var(--epods--icon-small)';
			break;

		default:
			iconStyles = iconBaseStyle;
			iconSize = 'var(--epods--icon-small)';
			break;
	}

	return {
		iconStyles: { ...iconStyles, ...props.style },
		iconSize,
		iconColor,
	};
};
